<template>
  <v-runtime-template :template="includeTemp"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'

export default {
  name: 'SurveyPopup',
  components: {
    VRuntimeTemplate
  },
  props: {
    isInquiry: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      includeHtml: '',
      params: {
        surveyTitleData: {},
        surveyResultData: {},
        mbrFnm: '',
        emailAddr: '',
        mbrCelno: '',
        wepId: this.getStore('mmpAuth').state.saveId,
        wepApcId: this.getStore('mmpAuth').state.session.userId,
        opinId: ''
      },
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      }
    }
  },
  computed: {
    includeTemp () {
      return this.includeHtml
    }
  },
  mounted () {
    if (this.isInquiry) {
      setTimeout(function () {
        let opinId = document.getElementById('opinId').value
        document.getElementById('opinCnt').innerHTML = document.getElementById(opinId).value.length + '/1000'
      }, 800)
    }
  },
  async created () {
    if (this.isInquiry) {
      this.getEmptyTemplate('wepInquiryPopup.html')
    } else {
      this.getEmptyTemplate('wepSurveyPopup.html')
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl, next) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.firstSubTemplate = res
        this.includeHtml = wepHtmlToString.firstSubTemplate
      })
    },
    fnSurveyPopClose () {
      if (this.isInquiry) {
        this.$emit('inquiryPopup', false)
      } else {
        this.$emit('satisfaction', false)
      }
    },
    getLayoutPopup (obj) {
      this.$emit('getLayoutPopup', obj)
    },
    async fnComplete () {
      let obj = {}

      obj = this.documentValidate()
      if (obj.flag) {
        this.params.surveyTitleData = obj.title
        this.params.surveyResultData = obj.input
        this.params.surveyItemTypeData = obj.itemType
        if (this.isInquiry) {
          this.params.survyScCd = '99'
        } else {
          this.params.survyScCd = '02'
        }
        if (document.getElementById('survyTitlNm') !== null) {
          this.params.survyTitlNm = document.getElementById('survyTitlNm').value
        }

        let resultInfo = await this.$http.mmp.evalAfterSurvey(this, this.params)
        if (resultInfo.data.status !== 'OK') {
          this.commAlert(this.$t('WEP00027'))
        } else {
          let alertTitle = ''
          if (this.isInquiry) {
            alertTitle = this.$t('WEP00053')
          } else {
            alertTitle = this.$t('WEP00050')
          }
          let alertParams = { title: alertTitle, contents: '', okBtnNm: this.$t('WEP00006'), cancelBtnNm: '' }
          let confirmRes = await this.$popup.confirm(this.$el, alertParams)
          if (confirmRes) {
            if (this.isInquiry) {
              this.$emit('inquiryPopup', false)
            } else {
              this.$emit('satisfaction', false)
            }
          }
        }
      }
    },
    fnLimitTextArea () {
      let opinId = document.getElementById('opinId').value
      if (document.getElementById(opinId).value.length > 1000) {
        document.getElementById(opinId).value = document.getElementById(opinId).value.substring(0, 1000)
      }
      document.getElementById('opinCnt').innerHTML = document.getElementById(opinId).value.length + '/1000'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/SurveyPopup.vue